import { useState, useEffect } from 'react';
import { useIntl } from "react-intl"
import ReactApexChart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';
import { getSectors, getStretcherBearerInformationForHeatMap } from '../../servicesHooks/Transfer/useTransferService';
import { Combobox, GetItemsProps, InputDate, getFirstDayOfMonthDate } from 'medere-ui-framework';
import { fromDateToString } from '../../utils/utils';
import { SectorDTO, defaultSectorDTO } from '../../dto/SectorDTO';

interface DayHours {
    description: string;
    _0: number;
    _1: number;
    _2: number;
    _3: number;
    _4: number;
    _5: number;
    _6: number;
    _7: number;
    _8: number;
    _9: number;
    _10: number;
    _11: number;
    _12: number;
    _13: number;
    _14: number;
    _15: number;
    _16: number;
    _17: number;
    _18: number;
    _19: number;
    _20: number;
    _21: number;
    _22: number;
    _23: number;
}


type DayHoursArray = DayHours[];

//deberíamos recibir sector origen y destino, fecha desde y hasta, sitio
const HeatMapPatientTransferView = () => {
    const intl = useIntl();
    const [series, setSeries] = useState<ApexAxisChartSeries | ApexNonAxisChartSeries | undefined>([]);
    const [maxValue, setMaxValue] = useState<number>(0);
    const [fromDate, setFromDate] = useState<Date>(getFirstDayOfMonthDate());
    const [toDate, setToDate] = useState<Date>(new Date());
    const [currentSector, setCurrentSector] = useState<any>(null);
    const [newSector, setNewSector] = useState<any>(null);

    // Función para generar datos aleatorios para el heatmap
    const generateHeatMapData = (dayHoursArray: DayHoursArray) => {
        return dayHoursArray.map(dayHours => ({
            name: dayHours.description,
            data: [
                dayHours._0, dayHours._1
                , dayHours._2, dayHours._3
                , dayHours._4, dayHours._5
                , dayHours._6, dayHours._7
                , dayHours._8, dayHours._9
                , dayHours._10, dayHours._11
                , dayHours._12, dayHours._13
                , dayHours._14, dayHours._15
                , dayHours._16, dayHours._17
                , dayHours._18, dayHours._19
                , dayHours._20, dayHours._21
                , dayHours._22, dayHours._23]
        }));
    };


    const findInformationForHeatMap = () => {
        getStretcherBearerInformationForHeatMap(currentSector != null ? currentSector.sector : null, newSector != null ? newSector.sector : null, fromDateToString(fromDate), fromDateToString(toDate)).then(data => {
            const transformedData = generateHeatMapData(data);
            setMaxValue(0);
            transformedData.forEach((o) => {
                const max = Math.max(...o.data);
                if (max > maxValue)
                    setMaxValue(max);
            });
            setSeries(transformedData); // Actualiza el estado 'series' con los datos transformados
        }).catch(error => {
            console.error('Error al obtener información para el heatmap:', error);
        });
    };

    // Llama a findInformationForHeatMap en un efecto para cargar los datos al montar el componente
    useEffect(() => {
        findInformationForHeatMap();
    }, [currentSector, newSector, fromDate, toDate]);

    const options: ApexOptions = {
        chart: {
            height: 350,
            type: 'heatmap',
        },
        dataLabels: {
            enabled: true
        },
        colors: ["#008FFB"],
        title: {
            text: 'Actividad por día y hora'
        },
        xaxis: {
            type: 'category',
            categories: ["0 am", "1 am", "2 am", "3 am", "4 am", "5 am", "6 am", "7 am", "8 am", "9 am", "10 am", "11 am",
                "12 pm", "13 pm", "14 pm", "15 pm", "16 pm", "17 pm", "18 pm", "19 pm", "20 pm", "21 pm", "22 pm", "23 pm"]
        },
        yaxis: {
            reversed: true
        },
    };

    return (
        <div className="m-4 h-96 viewContainer">
            <div className='inputs-container'>
                <Combobox className='margin-16' label={intl.formatMessage({ id: 'DestinySector' })} getItems={(itemProps: GetItemsProps) => {
                    return getSectors(itemProps).then((res: any) => {
                        return [defaultSectorDTO, ...res];
                    })
                }} optionLabel='name' setValue={(newSector: SectorDTO) => { setNewSector(newSector) }} value={newSector} />
                <Combobox className='margin-16' label={intl.formatMessage({ id: 'OriginSector' })} getItems={(itemProps: GetItemsProps) => {
                    return getSectors(itemProps).then((res: any) => {
                        return [defaultSectorDTO, ...res];
                    })
                }} optionLabel='name' setValue={(currentSector: SectorDTO) => { setCurrentSector(currentSector) }} value={currentSector} />
            </div>
            <div className='inputs-container'>
                <InputDate className='dateRange' label={intl.formatMessage({ id: 'from' })} value={fromDate} onChange={(e: any) => setFromDate(e.value)} />
                <InputDate className='dateRange' label={intl.formatMessage({ id: 'to' })} value={toDate} onChange={(e: any) => setToDate(e.value)} />
            </div>
            <div id="chart">
                <ReactApexChart options={options} series={series} type="heatmap" height={350} />
            </div>
        </div>
    );
}

export default HeatMapPatientTransferView;
